import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import { SpaceProps, space } from 'styled-system';
export const StyledSkeleton = styled(Skeleton)<SpaceProps>`
  transform: scale(1);
  ${space}
`;
